<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<ng-container *ngIf="serverError === null">

  <div class="floating-alert-container">
    <div class="alert alert-danger alert-dismissible" role="alert"
         *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-success alert-dismissible" role="alert"
         *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-info alert-dismissible" role="alert"
         *ngIf="loadingOrgConfig || loadingSave">
      Loading...
    </div>
  </div>

  <div style="position: relative">
    <div class="settings-col">
      <div class="pr-4 pt-4 mb-6">
      <h2 class="mb-3">
        Climber App Customization Settings
        <span *ngIf="loadingOrgConfig" class="text-muted"> - Loading...</span>
      </h2>

      <div class="alert alert-info d-md-block d-none">
        Use the preview window to the right to see how your settings will appear in the Climber App.
      </div>

      <div class="alert alert-info d-md-none">
        Open this page on a wider screen in order to preview your changes.
      </div>

      <form (submit)="save()" *ngIf="orgConfig">
        <div class="form-group">
          <label for="logoImageInput">Logo Image</label>
          <input id="logoImageInput" class="mb-2 d-block"
                 type="file" accept=".png"
                 (change)="attachLogoImageFile($event)">
          <small class="form-text text-muted">
            This must be a .png file no more than 2 MB in size. For proper display, the file should have a transparent background.
          </small>
          <div class="text-danger">
            {{ errors.logo_image }}
          </div>
        </div>
        <div class="form-group">
          <label for="logoHeightInput">
            Logo Height
          </label>
          <div class="input-group">
            <input id="logoHeightInput"
                   name="logo_height_px"
                   type="number" min="0" max="200"
                   class="form-control"
                   [(ngModel)]="orgConfig.logo_height_px"
                   (ngModelChange)="unsavedChanges = true">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
          <small class="form-text text-muted">
            Your logo's aspect ratio will be preserved, so setting this field also configures the logo's width.
          </small>
          <div class="text-danger">
            {{ errors.logo_height_px }}
          </div>
        </div>
        <div class="form-group">
          <label for="logoMarginTopInput">
            Logo Top Margin
          </label>
          <div class="input-group">
            <input id="logoMarginTopInput"
                   name="logo_margin_top_px"
                   type="number" min="0" max="200"
                   class="form-control"
                   [(ngModel)]="orgConfig.logo_margin_top_px"
                   (ngModelChange)="unsavedChanges = true">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
          <div class="text-danger">
            {{ errors.logo_margin_top_px }}
          </div>
        </div>
        <div class="form-group">
          <label for="logoMarginBottomInput">
            Logo Bottom Margin
          </label>
          <div class="input-group">
            <input id="logoMarginBottomInput"
                   name="logo_margin_bottom_px"
                   type="number" min="0" max="200"
                   class="form-control"
                   [(ngModel)]="orgConfig.logo_margin_bottom_px"
                   (ngModelChange)="unsavedChanges = true">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
          <div class="text-danger">
            {{ errors.logo_margin_bottom_px }}
          </div>
        </div>
        <div class="form-group">
          <label for="primaryColorHexInput">
            Primary Color (hex code)
          </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">#</span>
            </div>
            <input id="primaryColorHexInput"
                   name="custom_style_primary_color_hex"
                   type="text" maxlength="6" pattern="[A-Fa-f\d]{6}"
                   class="form-control"
                   [(ngModel)]="orgConfig.custom_style_primary_color_hex"
                   (ngModelChange)="unsavedChanges = true">
          </div>
          <div class="text-danger">
            {{ errors.custom_style_primary_color_hex }}
          </div>
        </div>
        <div class="form-group">
          <label for="cardBorderRadiusInput">
            Card Border Radius
          </label>
          <div class="input-group">
            <input id="cardBorderRadiusInput"
                   name="custom_style_card_border_radius_px"
                   type="number" min="0" max="50"
                   class="form-control"
                   [(ngModel)]="orgConfig.custom_style_card_border_radius_px"
                   (ngModelChange)="unsavedChanges = true">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
          <div class="text-danger">
            {{ errors.custom_style_card_border_radius_px }}
          </div>
        </div>
        <div class="form-group">
          <label for="buttonBorderRadiusInput">
            Button Border Radius
          </label>
          <div class="input-group">
            <input id="buttonBorderRadiusInput"
                   name="custom_style_button_border_radius_px"
                   type="number" min="0" max="50"
                   class="form-control"
                   [(ngModel)]="orgConfig.custom_style_button_border_radius_px"
                   (ngModelChange)="unsavedChanges = true">
            <div class="input-group-append">
              <span class="input-group-text">px</span>
            </div>
          </div>
          <div class="text-danger">
            {{ errors.custom_style_button_border_radius_px }}
          </div>
        </div>

        <!-- Place save button first so that the enter key press activates it -->
        <div class="float-right">
          <button type="submit" class="btn btn-primary"
                  [disabled]="loadingSave"
                  [class.disabled]="loadingSave">
            Save
          </button>
        </div>
        <button type="button" class="btn btn-secondary"
                (click)="loadOrganizationConfig()"
                [disabled]="loadingSave"
                [class.disabled]="loadingSave">
          Cancel
        </button>

      </form>
</div>
    </div>
    <div class="preview-col climber-app-preview">
      <p class="mb-3 text-center" style="margin-top: 42px">
        Climber App Preview
      </p>
      <div class="preview-container" *ngIf="orgConfig">
        <nav class="navbar navbar-dark navbar-capitan p-0" [ngStyle]="orgConfig.getClimberAppNavbarStyle()">
          <a class="navbar-brand" href="#" (click)="$event.preventDefault()">
            <img src="/assets/images/logo_white.svg"
                 class="capitan-logo-navbar d-inline-block align-top" alt="">
            <span style="position: relative; left: 5px;">CAPITAN</span>
          </a>

          <button class="navbar-toggler mr-2" type="button"
                  data-toggle="collapse" data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Home
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Settings
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Billing History &amp; Payment Methods
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  My Bookings
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Book Sessions &amp; Events
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Linked Accounts
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Challenges
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Memberships and Passes
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Document Center
                </a>
                <a class="nav-link" href="#" (click)="$event.preventDefault()">
                  Associations
                </a>
                <hr class="nav-collapse-separator my-2">
                <a class="nav-link mb-2"
                   href="#" (click)="$event.preventDefault()">
                  Log Out
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <div class="container position-relative mb-4" style="max-width: 700px">
          <div class="row mt-2">
            <div class="col">

              <img [src]="orgConfig.logo_image ? orgConfig.logo_image : '/assets/images/capitan-climbing-and-fitness-logo.png'"
                   [height]="orgConfig.logo_height_px"
                   [ngStyle]="orgConfig.getClimberAppLogoStyle()"
                   alt="org logo" style="display: block;margin: auto">

            </div>
          </div>

          <div class="card capitan-card mb-5" [ngStyle]="orgConfig.getClimberAppCapitanCardStyle()">
            <div class="card-header text-center" [ngStyle]="orgConfig.getClimberAppCapitanCardHeaderStyle()">
              My Upcoming Bookings
            </div>
            <div class="card-body">
              <div class="card-item">
                <p class="card-item-main">
                  March 19, 2024
                  9:00 AM -
                  11:00 AM
                </p>
                <p class="card-item-secondary">
                  Belay Class
                </p>
              </div>
              <hr>
              <a href="#" class="btn btn-outline-primary btn-block"
                 [ngStyle]="orgConfig.getClimberAppCapitanBtnStyle(isHoveringPreviewButton)"
                 (mouseenter)="isHoveringPreviewButton = true"
                 (mouseleave)="isHoveringPreviewButton = false"
                 (click)="$event.preventDefault()">
                Book Session or Event
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
